import { render, staticRenderFns } from "./Amenites.vue?vue&type=template&id=f27d568e&"
import script from "./Amenites.vue?vue&type=script&lang=js&"
export * from "./Amenites.vue?vue&type=script&lang=js&"
import style0 from "./Amenites.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports